import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { RoleAccess } from 'src/app/rgs/components/company-data/role/models/role-access.model';
import { RoleModuleKey } from 'src/app/rgs/components/company-data/role/models/role-module-key.model';
import { PermissionsService } from '../services/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class RoleAccessGuard {
  private readonly permissionsService = inject(PermissionsService);
  private readonly router = inject(Router);

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const module: RoleModuleKey | undefined = route.data['module'];

    const access: RoleAccess | undefined = route.data['access'];

    if (!module || !access) {
      return false;
    }

    const url = state.url;
    const urlParts = url.split('/');
    const urlFirstRoute = urlParts.at(-1);

    if (urlFirstRoute === 'objects') {
      return this.hasModulePermission$(module, access).pipe(
        tap((hasPermission) => {
          if (!hasPermission) {
            this.router.navigate(['dashboard']);
          }
        }),
      );
    }

    return this.hasModulePermission$(module, access);
  }

  public get hasModulePermission$() {
    return this.permissionsService.hasModulePermission$.bind(this.permissionsService);
  }
}
